import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import {BackendApiService} from '../services/backend-api.service';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import { CommonService } from '../services/common.service';
import _ from "lodash";
import { NgForm }   from '@angular/forms';
import { interval } from 'rxjs'; 
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private commonService: CommonService,
    private spinnerService: NgxSpinnerService) { }
    filter = {
      username:null,
      password : null
    }
    Toast = {
      type: '',
      title: '',
      timeout: 0,
      body: ''
    };
    password: string = '';
    hidePassword: boolean = true;
    
    invalidError:any = "";
    ngOnInit(): void {
    }
    loginSubmit(){
      this.spinnerService.show();
      let data = {
        "user_outo_no":this.filter.username,
        "user_pass_auto" : this.filter.password
      }
      this.backendApiService.login(data).subscribe(response => {
        if(response.status == false){
          this.spinnerService.hide();
          // this.showToster('Error', 'error', "Something went wrong.");
          this.invalidError = "Something went wrong";
          setTimeout(() => {
            this.invalidError = "";
          }, 2000);
        }else{
          if(response['data']['allowed'] == true){
            if(response['data']['BADLA'] == 'Y'){
              this.spinnerService.hide();
              let userObj= {
                userId : this.filter.username
              }
              this.backendApiService.createAuthToken(userObj).subscribe(responseAuth => {
                if(responseAuth['status'] == true){
                  this.router.navigate(['/livebadla/',responseAuth['token']]);
                }else{
  
                }
                // this.router.navigate(['/dashboard']);
              });  
            }else{
              this.spinnerService.hide();
              this.invalidError = "You do not have access of badla module.";
              setTimeout(() => {
                this.invalidError = "";
              }, 3500);             
            }
          }else{
            this.spinnerService.hide();
            this.invalidError = response['data']['messege'];
            setTimeout(() => {
              this.invalidError = "";
            }, 3500);
          }  
        }
      })
    }

  showToster(title, type, message) {
    this.Toast.title = title;
    this.Toast.type = type;
    this.Toast.body = message;
    this.commonService.popToast(type, title, 1500, message);
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

}
